export const Config = {
    appname: "W&W Portal"
};
